import { useEffect, useState } from "react";
import { theme } from "../constants/StyledComponents";

export const useDimensions = () => {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  useEffect(() => {
    const handler = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return {
    ...dimensions,
    isMobile: dimensions.width < theme.breakpoints.MD,
    isTablet:
      dimensions.width >= theme.breakpoints.MD &&
      dimensions.width < theme.breakpoints.LG,
    isLaptop:
      dimensions.width >= theme.breakpoints.LG &&
      dimensions.width < theme.breakpoints.XL,
    isDesktop: dimensions.width >= theme.breakpoints.XL,
  };
};
